const translations = {
    certificateOfAuthorizationNumber: 'Certificate of Authorization Number',
    certificationsAndExemptions: 'Certifications and Exemptions',
    faaDocketNumber: 'FAA Docket Number',
    faaExemptionNumber: 'FAA Exemption Number',
    noCertifications: 'There are currently no certifications or exemptions'
};

export default translations;
